export default "__VITE_ASSET__CaksX84A__"